import { CHAIN_SUPPORTS_REFERRAL } from '@/config'
import { useSelectedDenom } from '@/contexts/denom'
import { useReferral } from './ReferralProvider'
import { env } from '@/utils'
import { Badge } from '@mantine/core'

const ReferralDebugger = () => {
  const { referral } = useReferral()

  const [selectedCoinDenom] = useSelectedDenom()

  const isProduction = !['development', 'staging'].includes(env('STRIDE_ENV'))

  if (isProduction) {
    return null
  }

  if (referral == null || !CHAIN_SUPPORTS_REFERRAL[selectedCoinDenom]) {
    return null
  }

  return (
    <>
      <Badge color="pink" variant="filled" size="xs">
        Referral code: {referral}
      </Badge>
    </>
  )
}

export { ReferralDebugger }
